export class WalletSummary {    
    totalBalance: number
    holds: number
    clearBalance: number

    constructor(totalBalance: number, holds: number, clearBalance: number) {                
        this.totalBalance = totalBalance
        this.holds = holds
        this.clearBalance = clearBalance
    }
}